import type { PackageBundle } from '../app/types';

import type { CoinBackPackageBundle } from './types';

export const isCoinBackPackageBundles = (
  packageBundles: PackageBundle[],
): packageBundles is CoinBackPackageBundle[] => {
  return packageBundles.every((bundle) => bundle.bundleType === 'coinBack');
};
